import { useEffect } from 'react';
import { useWebSocket } from '@/hooks/use-websocket';
import { useChatStore } from '@/stores/chat-store';
import { useConfigQuery } from '@/queries/use-config-query';
import { useUnitBranding } from '@/hooks/use-unit-branding';
import { MapContainer } from '@/components/map/map-container';
import { IconRail } from '@/components/layout/icon-rail';
import { PanelContainer } from '@/components/layout/panel-container';

/** Root application component */
export function App(): React.JSX.Element {
  useWebSocket();
  useConfigQuery();
  useUnitBranding();

  useEffect(() => {
    useChatStore.getState().loadRooms();
  }, []);

  return (
    <>
      <MapContainer />
      <IconRail />
      <PanelContainer />
    </>
  );
}
